import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { handleApiError, MutationConfig } from '@/lib/react-query'
import { PublicDto } from '@/types'

import { refreshTokenAndUpdateStore } from '../services/refreshTokenService'

const refreshToken = (refreshToken: string): Promise<PublicDto['UserTokenDto']> => {
  return refreshTokenAndUpdateStore(refreshToken)
}

type UseRefreshTokenOptions = {
  config?: MutationConfig<typeof refreshToken>
}

export const useRefreshToken = ({ config }: UseRefreshTokenOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: refreshToken,
    onSuccess: (data, vars, onRes, ctx) => {
      // Store is automatically updated by refreshAndUpdateStore
      config?.onSuccess?.(data, vars, onRes, ctx)
    },
    onError: (error: AxiosError<PublicDto['ExceptionDetails']>, vars, onRes, ctx) => {
      handleApiError(error)
      config?.onError?.(error, vars, onRes, ctx)
    },
  })
}
